import { render, staticRenderFns } from "./modal-notification.vue?vue&type=template&id=c7e09ed4&scoped=true"
import script from "./modal-notification.vue?vue&type=script&lang=js"
export * from "./modal-notification.vue?vue&type=script&lang=js"
import style0 from "./modal-notification.vue?vue&type=style&index=0&id=c7e09ed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e09ed4",
  null
  
)

export default component.exports